<template>
  <div class="ac1000-dialog" v-if="visible">
    <div class="mask"></div>
    <div class="content-wrap">
      <div class="header">
        <span>{{ title }}</span>
        <span class="close" @click="cancel">X</span>
      </div>
      <div class="content">
        <slot></slot>
      </div>
      <div class="footer" v-if="hasOperations">
        <el-button type="primary" @click="confirm" :loading="loading">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: true
    },
    hasOperations: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    showLoading() {
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
    confirm() {
      const loading = {
        show: () => this.showLoading(),
        hide: () => this.hideLoading()
      };
      this.$emit('confirm', loading);
    },
    cancel() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss">
.ac1000-dialog {
  width: 100%;
  height: 100%;
  border-radius: 8px;

  position: absolute;
  left: 0;
  top: 0;

  .mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
  }

  .content-wrap {
    width: 1000px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    padding: 2em 0 4em;

    .header {
      padding: 0 1.675em 2em;

      display: flex;
      justify-content: space-between;

      span {
        font-size: 2.5em;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #000024;
      }

      .close {
        cursor: pointer;

        font-family: unset;

        &:hover {
          color: #0f2f80;
          filter: brightness(1.2);
        }
      }
    }

    .footer {
      padding: 4em 0 0;
      display: flex;
      justify-content: center;
      .el-button {
        margin: 0 2em;
        padding: 1em 4em;
        span {
          font-size: 2em !important;
        }

        &:nth-of-type(1) {
          background: #0f2f80;
          border: 1px solid #0f2f80;
          color: #fff;
        }

        &:nth-of-type(2) {
          background: #fff;
          border: 1px solid #0f2f80;
          color: #0f2f80;
        }
      }
    }
  }
}
</style>
